import React, { useState, useEffect } from "react";
import { Grid } from "fluentui-react-grid";
import SaveButton from "@/ui-controls/SaveButton";
import CancelButton from "@/ui-controls/CancelButton";
import TextInput from "@/ui-controls/TextInput";
import { Role } from "@/api/roles";
import { Application } from "@/api/applications";
import { Customer } from "@/api/customers";
import {
  User,
  addApplicationCustomerUserRoles,
  ApplicationCustomerUserRoles,
} from "@/api/users";
import RoleSelectDetailList from "@/components/roles/appCustomerUserRoles/RoleSelectDetailList";

interface Props {
  application: Application;
  customer: Customer;
  user: User;
  allAppRoles: Role[];
  unassignedAppRoles: Role[];
  onSave?: (
    newApplicationCustomerUserRoles: ApplicationCustomerUserRoles
  ) => any;
  onClose?: () => any;
}

const NewAppCustomerUserRoleForm = (props: Props) => {
  const [showNewAppRoleForm, setShowNewAppRoleForm] = useState<boolean>(false);
  const [filteredRoleValue, setFilteredRoleValue] = useState<
    string | undefined
  >(undefined);
  const [filteredRoles, setFilteredRoles] = useState<Role[]>([]);
  const [selectedRoles, setSelectedRoles] = useState<Role[]>([]);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  useEffect(() => {
    filterRoles(filteredRoleValue);
  }, [props.unassignedAppRoles]);

  const onFilter = (
    ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    text: string | undefined
  ) => {
    setFilteredRoleValue(text);
    filterRoles(text);
  };

  const filterRoles = (text: string | undefined) => {
    setFilteredRoles(
      text
        ? props.unassignedAppRoles.filter(
            (i) => i.Name.toLowerCase().indexOf(text.toLowerCase()) > -1
          )
        : props.unassignedAppRoles
    );
  };

  const saveUserRoles = () => {
    setIsSaving(true);

    const appCustomerUserRoles: ApplicationCustomerUserRoles = {
      AppId: props.application.Id,
      CustomerId: props.customer.Id,
      UserId: props.user.Id,
      RoleIds: selectedRoles.map((c) => c.Id),
    };

    addApplicationCustomerUserRoles(appCustomerUserRoles).then(
      (_) => {
        setIsSaving(false);
        if (props.onSave) props.onSave(appCustomerUserRoles);
      },
      (error) => {
        setIsSaving(false);
        handleError(error);
      }
    );
  };

  const onCancelForm = () => {
    if (props.onClose) props.onClose();
  };

  const handleError = (error: any) => {
    // Error handled by parent component
  };

  return (
    <>
      <div style={{ display: showNewAppRoleForm ? "none" : "block" }}>
        <Grid dir="ltr">
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Filter roles:"
                baseTypeProps={{
                  onChange: onFilter,
                }}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <RoleSelectDetailList
              appRoles={filteredRoles}
              onSelectionChanged={(roles) => {
                setSelectedRoles(roles);
              }}
            />
          </Grid.Row>
          <Grid.Row className="panel-buttons">
            <Grid.Col>
              <SaveButton
                text="Save"
                baseTypeProps={{
                  disabled:
                    isSaving || !selectedRoles || selectedRoles.length < 1,
                }}
                onClick={() => saveUserRoles()}
              />
            </Grid.Col>
            <Grid.Col>
              <CancelButton
                text="Cancel"
                onClick={onCancelForm}
                baseTypeProps={{ disabled: isSaving }}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </div>
    </>
  );
};

export default NewAppCustomerUserRoleForm;
